import AutoPay from '../../assets/icons/AutoPay';
import Bill from '../../assets/icons/Bill';
import Clipboard from '../../assets/icons/Clipboard';
import CreditCard from '../../assets/icons/CreditCard';
import Document from '../../assets/icons/Document';
import DocumentNav from '../../assets/icons/DocumentNav';
import Envelope from '../../assets/icons/Envelope';
import Gear from '../../assets/icons/Gear';
import HomeSideBar from '../../assets/icons/HomeSideBar';
import Lock from '../../assets/icons/Lock';
import MagazineOutline from '../../assets/icons/MagazineOutline';
import Shield from '../../assets/icons/Shield';
import SignOut from '../../assets/icons/SignOut';
import TextBubble from '../../assets/icons/TextBubble';

export interface DrawerItem {
  Component: React.ComponentType;
  text: string;
  extra?: string;
  path?: string;
  subCategory?: DrawerItem[];
}

export const drawerMap: { [name: string]: DrawerItem } = {
  Home: { Component: HomeSideBar, text: 'Home', path: '/' },
  Bill: {
    Component: Bill,
    text: 'Bills and payments',
    subCategory: [
      {
        path: '/bills',
        Component: DocumentNav,
        text: 'Bills',
        extra: 'Make a payment',
      },
      {
        Component: AutoPay,
        text: 'AutoPay settings',
        path: '/autopay',
      },
      {
        Component: CreditCard,
        text: 'Payment methods',
        path: '/wallet',
      },
      {
        Component: MagazineOutline,
        text: 'Transaction history',
        path: '/transaction-history',
      },
    ],
  },
  Shield: { Component: Shield, text: 'Policies', path: '/policies' },
  Document: {
    Component: Document,
    text: 'Document library',
    extra: 'Get ID cards',
    path: '/documents',
  },
  Clipboard: {
    Component: Clipboard,
    text: 'Claims',
    extra: 'Start a claim',
    path: '/claims',
  },
  Settings: {
    Component: Gear,
    text: 'MyPolicy settings',
    subCategory: [
      {
        Component: Envelope,
        text: 'Communication preferences',
        path: '/preferences',
      },
      {
        Component: Lock,
        text: 'Password',
        path: '/change-password',
      },
    ],
  },
  Envelope: {
    Component: Envelope,
    text: 'Communication preferences',
    path: '/preferences',
  },
  TextBubble: {
    Component: TextBubble,
    text: 'Contact us',
    path: '/contact-us',
  },
  SignOut: { Component: SignOut, text: 'Sign out' },
};
